import { render, staticRenderFns } from "./svd.vue?vue&type=template&id=ff0f46ea&scoped=true&"
import script from "./svd.vue?vue&type=script&lang=js&"
export * from "./svd.vue?vue&type=script&lang=js&"
import style0 from "./svd.vue?vue&type=style&index=0&id=ff0f46ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0f46ea",
  null
  
)

export default component.exports